import { useEffect } from "react";
import {
  useComponent,
  useElement,
  useLocale,
  useService,
  useWidget,
} from "../../../hooks";
import { brandInfo } from "../../../constant";
import "./style.scss";

export const About = () => {
  const { t } = useLocale();
  const Banner = useWidget("Banner");
  const Img = useElement("Img");
  const Link = useElement("Link");
  const { setTitle, setDescription, setKeywords } = useService("Meta");
  const ShowServices = useComponent("ShowServices");
  const StepProvide = useComponent("StepProvide");
  useEffect(() => {
    setTitle(t("aboutPage.meta.title").replace("{brand}", brandInfo.name.capital), "empty");
    setDescription(
      t("aboutPage.meta.description").replace(/{brand}/g, brandInfo.name.capital)
    );
    setKeywords(
      t("aboutPage.meta.keywords").replace(/{brand}/g, brandInfo.name.capital)
    );
  }, [t, setDescription, setKeywords, setTitle]);
  return (
    <div className="about-page">
      <Banner title={t("aboutUs")} image="about-4.jpg" />
      <div className="mt60 wrapper jumbo-container">
        <div className="left-section">
          <p>
            {t("aboutPage.p1")
              .replace("{brand}", brandInfo.name.capital)
              .replace("{company}", brandInfo.companyName)}
          </p>
          <p>
            {t("aboutPage.p2").replace("{brand}", brandInfo.name.capital)}
          </p>
          <Link className="btn btn-big btn-primary" href="/services">
            {t("services")}
          </Link>
        </div>
        <div className="right-section"></div>
      </div>
      <div className="jumbo-container">
        <h2 className="heading-02 mt60">
          {t("aboutPage.provideTitle").replace("{brand}", brandInfo.name.capital)}
        </h2>
        <StepProvide />
      </div>
      <section className="our-usp">
        <div className="jumbo-container wrapper">
          <div className="right-section">
            <h3 className="fs20">{t("aboutPage.uspTitle")}</h3>
            <p>
              <b>
                {t("aboutPage.uspSubTitle")}
              </b>
            </p>
            <ul>
              <li>{t("aboutPage.usp1")}</li>
              <li>{t("aboutPage.usp2")}</li>
              <li>{t("aboutPage.usp3")}</li>
              <li>{t("aboutPage.usp4")}</li>
              <li>{t("aboutPage.usp5")}</li>
            </ul>
          </div>
        </div>
      </section>
      <section className="mt60 service-type-list">
        <div className="jumbo-container">
          <h2 className="heading-02 tac">
            {t("aboutPage.novelExperience").replace("{brand}", brandInfo.name.capital)}
          </h2>
          <ShowServices />
        </div>
      </section>
      <section className="join-us">
        <div className="jumbo-container">
          <Img src="speaker.png" />
          <h1>{t("aboutPage.joinFamily").replace("{brand}", brandInfo.name.capital)}</h1>
          <p>
            {t("aboutPage.p3").replace("{brand}", brandInfo.name.capital)}
          </p>
          <p>
            {t("aboutPage.p4").replace("{brand}", brandInfo.name.capital)}
          </p>
        </div>
      </section>
    </div>
  );
};
